import CommandTask from '../forms/sys/remote/CommandTask';
import Cmd from '../forms/sys/remote/Cmd';
import Command from '../remote/Command';
import ServiceHelper from '../remote/ServiceHelper';
import OpenFormArg from '../forms/sys/remote/OpenFormArg';
import CommandResolver from '../utils/CommandResolver';
import Gongqi_ProgressBar from './Gongqi_ProgressBar';
import Warning from '../utils/Warn';
import ReactDOM from 'react-dom';
import OverallSituationModelDiv from './OverallSituationModelDiv';
import React from 'react';

export default class WebSocketManager {
  static websocket;

  static closeKey = 0;
  static TimeArray = [3000, 10000, 15000, 30000, 60000, 120000, 180000, 300000, 600000, 900000, 1800000, 3600000, 7200000];

  static heartCheck = {
    timeout: 2000,//60s
    timeoutObj: null,
    reset: function () {
      clearTimeout(this.timeoutObj);
      this.start();
    },
    start: function () {
      this.timeoutObj = setTimeout(function () {
        WebSocketManager.websocket.send("HeartBeat");
      }, this.timeout)
    },
    stop: function () {
      clearTimeout(this.timeoutObj);
    }
  }

  static initWebSocket () {
    /*let domain = "";
    if(window.didomain)
      domain = "/"+didomain;*/
    var url = window.userInfos.serviceURL.replace("http", "ws") + "/websocket_erp";
    if ('WebSocket' in window) {
      WebSocketManager.websocket = new WebSocket(url);
      //websocket = new WebSocket("ws://www.gongqi.info:10201/GongqiERP/websocket_erp");
    }
    else {
      Warning.show({text:"浏览器版本过低 不支持消息"});
      return;
    }

    //连接发生错误的回调方法
    WebSocketManager.websocket.onerror = WebSocketManager.webSocketOnError;

    //连接成功建立的回调方法
    WebSocketManager.websocket.onopen = WebSocketManager.webSocketOnOpen;

    //接收到消息的回调方法
    WebSocketManager.websocket.onmessage = WebSocketManager.webSocketOnMessage;
    
    //连接关闭的回调方法
    WebSocketManager.websocket.onclose = WebSocketManager.webSocketOnClose;

  }

  static webSocketOnError () {
    if (WebSocketManager.closeKey < (WebSocketManager.TimeArray.length - 1)) {
      $("#messagesError").css("display", "block");
      $("#messagesSuccess").css("display", "none");
    } else if (WebSocketManager.closeKey == (WebSocketManager.TimeArray.length - 1)) {
      Warning.show({text:"消息连接发生错误！您可能无法正常收到消息提示，请联系管理员以免影响正常使用"});
    }
  }

  static webSocketOnOpen () {
    WebSocketManager.heartCheck.start();
    WebSocketManager.closeKey = 0;
    WebSocketManager.getUnReadCounts();
    WebSocketManager.getUnReadList();
  }

  static getUnReadCounts () {
    var command = Command.createService("gongqi.erp.framework.services.MessageService", "getUnReadedCounts", "int");
    ServiceHelper.addTokenWithCommand({ command: command, resultFunction: WebSocketManager.getUnReadCountsResultHandler });
  }

  static getUnReadCountsResultHandler (data) {
    if (data.status == 0) {
      var UnReadMessageCount = data.result;
      $("#MessageDropDownMenuContainer #Message-Number-Num").html(UnReadMessageCount);
      if(UnReadMessageCount == 0 || UnReadMessageCount == '0'){
        $("#Message-Number-Icon").css("display", "none");
      }else{
        $("#Message-Number-Icon").css("display", "block");
      }
      $("#Message-Number-Icon").text(UnReadMessageCount);
      $("#Message-Number-Num").text(UnReadMessageCount);
      if (UnReadMessageCount != WebSocketManager.oldmessagenum) {
        WebSocketManager.oldmessagenum = UnReadMessageCount;
        $("#famessageIcon").addClass("faa-horizontal animated");
        $("#Message-Number-Icon").addClass("faa-bounce animated");
        var x = setTimeout(function () {
          clearTimeout(x);
          $("#famessageIcon").removeClass("faa-horizontal animated");
          $("#Message-Number-Icon").removeClass("faa-bounce animated");
        }, 8000);
      }
    }
  }

  static getUnReadList () {
    var command = Command.createService("gongqi.erp.framework.services.MessageService", "getSysMessageUnReadList", "List");
    command.appendArg(5, "int");
    ServiceHelper.addTokenWithCommand({ command: command, resultFunction: WebSocketManager.getUnReadListHandler });
  }

  static getUnReadListHandler (data) {
    /**
     * <li>
                    <!-- start message -->
                    <a href="#">
                      <div class="pull-left">
                        zxx
                      </div>
                      <h4>
                        Support Team
                        <small><i class="fa fa-clock-o"></i> 5 mins</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
     */

    $("#MessageDropDownMenuContainer .menu li").remove();
    for (let i in data.result) {
      let mItem = data.result[i];
      let fromUserId = mItem.from.split(",")[1];
      let time = mItem.time;
      //fromUserId = "89565656448-dfd-7878";
      if (fromUserId && fromUserId.length > 7)
        fromUserId = fromUserId.substr(0, 7) + "...";
      let $div = $("<div class='pull-left' style='float: right !important;'>").html(fromUserId);
      let small = $("<small style='color: #999999;'><i class='fa fa-clock-o'></i>" + time + "</small>")
      let _msgLabel = mItem.bodyLabel;
      if (_msgLabel && _msgLabel.length > 15) {
        _msgLabel = _msgLabel.substr(0, 15) + "...";
      }
      let $h4 = $("<h4 style='font-weight: bold;font-size: 12px;'>").text(_msgLabel ? _msgLabel : "您有新的消息请点击阅读");
      let $a = $("<a style='cursor:pointer'>").append($div).append($h4).append(small);
      $a.click(function (e) { window.openMessageCenter(e, mItem.messageId) });
      $("<li>").append($a).appendTo($("#MessageDropDownMenuContainer .menu"));
    }

  }

  static readSingleMessage () {

  }

  static oldmessagenum = 0;

  static progressBar = null;

  static webSocketOnMessage () {
    $("#messagesError").css("display", "none");
    $("#messagesSuccess").css("display", "block");
    if (event.data == "HeartBeat") {
      WebSocketManager.heartCheck.reset();
      return;
    }

    var data_ = event.data;
    data_ = JSON.parse(data_);
    if (data_.type == "SysMessageTable") //接收到消息
    {

      try {
        let _body = JSON.parse(data_.body);
        if (_body.type == "CommandResult") {
          let commandResult = _body.commandResult;
          var modalList = $("#formModal .modal");
          let formModule = null;
          if (modalList.length > 0) {
            var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
          }
          else {
            var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
          }

          if (nextIframe.length != 0) {
            var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
            formModule = win.formModuleInstance;
            if (!formModule) return;
            if((!commandResult.tasks))return;
            if(commandResult.tasks.length ==0)return;
            CommandResolver.resolve(commandResult.tasks, formModule);
          }

        }
        return;
      }
      catch (e) {

      }

      //当有一般类型的消息 如果有自定义 则自定义与系统本身消息记录及数量更新都要执行
      if (window.messageHandler) {
        sessionStorage.setItem("new_message", event.data)
        $("#messageContainer").load(window.messageHandler);
      }
      WebSocketManager.getUnReadCounts();
      WebSocketManager.getUnReadList();

      if (data_.modal == true) {
        Warning.show({ text: data_.body, title: "管理员重要通知" });
      }
    }
    if (data_.type == "SysMessageCountsChanged") //接收到消息
    {
      WebSocketManager.getUnReadCounts();
      WebSocketManager.getUnReadList();
    }
    else if (data_.MessageType == "Content") {
      MessageWarning.show({
        text: data_.body
      });

    }
    else if (data_.messageType == "openForm") {
      var openFormArg = new OpenFormArg();
      openFormArg.menuItemId = data_.menuItemId;
      openFormArg.paramString = data_.parameters;
      if (openFormArg.menuItemId == "50000027" || data_.ingnoreAu)
        openFormArg.ingnoreAu = true;

      CommandResolver.openForm({ arg: openFormArg }, null);
    }
    else if (data_.messageType == "callFormCmd" || data_.type == "callFormCmd") {
      var dataObj = data_;
      var menuItemId = dataObj.menuItemId;
      var methodName = dataObj.methodName;
      var methodArg = dataObj.argObject;
      var arg = { methodName: methodName, methodArg: methodArg };


      var commandTask = new CommandTask();
      commandTask.cmd = Cmd.FormCmd;
      var tasks = [commandTask];

      commandTask.arg = arg;

      window.toobarFunc(null, "callFormCmd", tasks);
    }
    else if (data_.messageType == "ProgressBar" || data_.type == "ProgressBar") {
      let body = JSON.parse(data_.body);
      if (body.cmd == "popUp") {

        if (!WebSocketManager.progressBar) {
          WebSocketManager.closeMLoading();
          WebSocketManager.progressBar = Gongqi_ProgressBar.show(body);
        }

        /*if($("#gongqi_globalProgress").length == 0)
        {
          let progressBar=$('<progress></progress>').css({'width':'15em','height':'2.1em'}).html('您的浏览器不支持progress元素').attr("max",body.total).attr("value",body.loaded>0?body.loaded:0);
          let progressA=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
          let progressBtn=$('<div></div>').append(progressA);
          let progressDiv=$('<div></div>').css({'position':'absolute','top':'40.5%','left':'40%','display':'flex','height':'100px','align-items':'flex-end'}).append(progressBar).append(progressBtn);
          let percentageDiv=$("<span class='globalProgress_precent'></span>").html(body.text?body.text:"");
          let time=$("<span class='globalProgress_time'></span>");
          let percentDiv=$('<div></div>').css({'position':'absolute','top':'79%','width':'calc(100% - 20px)','display':'flex',
          'justify-content':'center','font-size':'0.8em'}).append(percentageDiv).append(time).appendTo(progressDiv);
          let progressBorder=$("<div id='gongqi_globalProgress' style='display:block'></div>").append(progressDiv).addClass('modal');
          $('body').append(progressBorder);
        }*/

      }
      else if (body.cmd == "update") {
        if (WebSocketManager.progressBar) {
          WebSocketManager.closeMLoading();
          WebSocketManager.progressBar.setState({
            title: body.title,
            total: body.total,
            loaded: body.loaded,
            text: body.text
          });
        }
        /*let progressBar = $("#gongqi_globalProgress progress");

        //progressBar.attr('max',body.total);
        progressBar.attr('value',body.loaded);

        if(body.total>0 && (progressBar.attr('max')+"") != (body.total+""))
          progressBar.attr('max',body.total);

        let percentageDiv = $("#gongqi_globalProgress .globalProgress_precent")

        if(percentageDiv.text() != body.text)
          percentageDiv.html(body.text);*/
      }
      else if (body.cmd == "close") {
        if (WebSocketManager.progressBar) {
          WebSocketManager.progressBar.closeHandler();
        }

        /*let progressBorder = $("#gongqi_globalProgress");
        progressBorder.remove();*/
      }

    }
    else if(data_.type == 'SystemMaintain' && data_.body == "true" ){
      let _parentWindow = window.parent.window
      let userInfos = _parentWindow.userInfos||window.userInfos;
         
      if(!userInfos.isAdmin){
        document.getElementById('overallSituationDiv').style = "width: 100%;height: 100%;position: absolute;top: 0;left: 0;z-index: 9999";
        ReactDOM.render(<OverallSituationModelDiv />, document.getElementById('overallSituationDiv'));
      }       
                 
    }else if(data_.type == 'SystemMaintain' && data_.body == "false"){
      document.getElementById('overallSituationDiv').style = "display:none !important";
    }

  }

  static closeMLoading () {
    var popIframes = $("#formModal iframe");
    if (popIframes.length > 0) {
      iframe = popIframes.get(popIframes.length - 1);
      let win;
      try {
        win = iframe.window || iframe.contentWindow;
      }
      catch (e) { }
      if (win) {
        win.$("body").mLoading("hide");
      }
    }
    else {
      var arr = $("#g_tab_content>div.tab-pane.active iframe");
      if (arr.length > 0) {
        var iframe = arr.get(0);
        let win;
        try {
          win = iframe.window || iframe.contentWindow;
        }
        catch (e) { }
        if (win) {
          win.$("body").mLoading("hide");
        }

      }
    }

    window.$("body").mLoading("hide");
  }

  static webSocketOnClose () {

    if (WebSocketManager.closeKey < WebSocketManager.TimeArray.length) {
      setTimeout(function () {

        WebSocketManager.heartCheck.stop();

        WebSocketManager.initWebSocket();

        WebSocketManager.closeKey += 1;
      }, WebSocketManager.TimeArray[WebSocketManager.closeKey - 1]);
    } else {
      Warning.show({text:"消息连接已关闭！您可能无法正常收到消息提示，请联系管理员以免影响正常使用"});
    }
  }
}
export class MessageWarning {

  static show (options) {

    var defaults = {
      state: "info",
      backgroundColor: '#fff',
      color: "#000",
      text: "",
      cornerRadius: "10",
      fontSize: '14px',
      interacdestroy: false,
      confirm: {
        isShow: true,
        event: ''
      },
      cancel: {
        isShow: false,
        event: ''
      }

    }

    var titleMsg = {
      info: '提示信息'
    }

    var btnStyle = {
      info: {
        color: '#fff',
        backgroundColor: '#3c8dbc',
        width: '70px',
        height: '35px',
        padding: '5px 5px',
        fontSize: '14px'
      }
    }

    var btnContent = {
      info: '确认'
    }

    $.extend(true, defaults, options);

    var closeSpan = $('<span></span>').html('×').css({ 'font-size': '25px' });
    var closeBtn = $('<button></button>').addClass('close').attr('type', 'button').append(closeSpan);
    closeBtn.on('click', function () {
      $(alertDiv).remove();
    })
    var titleH = $('<h4></h4>').addClass('modal-title').html(titleMsg[defaults.state]).css({ 'font-weight': '500' });//判断显示内容
    var headerDiv = $('<div></div>').addClass('modal-header').append(closeBtn).append(titleH).css({ 'padding': '10px' });

    var bodyP = $('<p></p>').html(text).css({ 'font-size': defaults.fontSize });
    var bodyDiv = $('<div></div>').addClass('modal-body').append(bodyP);

    // var cancelBtn=$('<button></button>').attr('type','button').addClass('btn btn-default').html('取消').css({'width':'70px','height':'35px','padding':'5px 5px','font-size':'16px'});
    var confirmBtn = $('<button></button>').attr('type', 'button').addClass('btn').css(btnStyle[defaults.state]).html(btnContent[defaults.state]).css('margin-right', '20px');
    //判断是否显示取消确定按钮
    var footerDiv = $('<div></div>').addClass('modal-footer').css({ 'border-top': 'none', 'padding-right': '30px', 'padding-bottom': '30px' });

    if (defaults.confirm.isShow)
      footerDiv.append(confirmBtn);

    if (defaults.cancel.isShow)
      footerDiv.append(cancelBtn);

    confirmBtn.on('click', function () {
      if (typeof (defaults.confirm.event) == "function") {
        defaults.confirm.event();
      }
      $(alertDiv).remove();
    });


    if (defaults.cancel.event == '') {
      cancelBtn.on('click', function () {
        $(alertDiv).remove();
      })
    }
    var contentDiv = $('<div></div>').addClass('modal-content').append(headerDiv).append(bodyDiv).append(footerDiv);

    var dialogDiv = $('<div></div>').append(contentDiv).css({ 'margin': '18% auto', 'position': 'relative', 'width': 'auto', 'min-width': '390px' });

    var alertDiv = $('<div></div>').addClass('modal').append(dialogDiv).css({ 'display': 'flex' });

    parent.$("body").append(alertDiv);

  }
}



// WEBPACK FOOTER //
// ./src/websocket/WebSocketManager.js